/**
 * Pip path constants — extracted VERBATIM from tasks/mascot-options/pip.html.
 *
 * This file is the single source of path truth for apps/web. Production code
 * copies FROM pip.html; never the reverse (plan §1 "Asset source of truth").
 *
 * Token map applied at extraction time (plan rev 3.1):
 *   var(--ink)    → var(--text)   (the only rename — --ink is absent from
 *                                  packages/ui tokens; --text is the canonical
 *                                  primary-ink token)
 *   var(--accent) → var(--accent) (unchanged)
 *   var(--surface)→ var(--surface)(unchanged)
 *
 * Drift is mechanical, not honour-system: the Vitest fixture in
 * PipMascot.test.tsx asserts every string below appears verbatim in
 * tasks/mascot-options/pip.html. Editing geometry here without updating the
 * fixture fails that test.
 */

/** Main SVG viewBox — 120×120 */
export const VIEW_BOX = "0 0 120 120";

// ── Body ──────────────────────────────────────────────────────────────────────

/** F1 / Nubs hero body path (used by every non-glyph placement) */
export const BODY =
  "M27 74 C26 55 40 40 61 40 C82 40 95 55 94 74 C92 84.5 89 87 61 87 C33 87 29 84.5 27 74 Z";

/** Left nub */
export const NUB_LEFT = "M31 70 C24.5 71 23.5 79 31 80";

/** Right nub */
export const NUB_RIGHT = "M91 70 C97.5 71 98.5 79 91 80";

// ── Glyph cut (<32 px) ────────────────────────────────────────────────────────

/** F6 Glyph body — chunkier stroke, used at size < 32 px */
export const GLYPH_BODY =
  "M34 76 C34 56 45 46 60 46 C75 46 86 56 86 76 C84 83 80 85 60 85 C40 85 36 83 34 76 Z";

/** Glyph poke — slightly larger for small-size legibility */
export const GLYPH_POKE = { cx: 71, cy: 58.5, r: 3.4 };

/** Glyph eye dots — dot-only at small sizes */
export const GLYPH_EYES_OPEN = [
  { cx: 52, cy: 66, r: 3.4 },
  { cx: 66, cy: 66, r: 3.4 },
];

// ── Poke (accent dot) ─────────────────────────────────────────────────────────

export const POKE = { cx: 77, cy: 56, r: 3.2 };

// ── Facial features ───────────────────────────────────────────────────────────

/** Eyes closed — two arcs, content/resting state */
export const EYES_CLOSED = ["M46 64 Q50 60.5 54 64", "M60 64 Q64 60.5 68 64"];

/** Eyes open — dot circles, used during actions */
export const EYES_OPEN = [
  { cx: 50, cy: 63.5, r: 2.8 },
  { cx: 64, cy: 63.5, r: 2.8 },
];

/** Eyes sad — inverted arcs, used in settle action */
export const EYES_SAD = ["M46 62 Q50 65.5 54 62", "M60 62 Q64 65.5 68 62"];

/** Smile arc */
export const SMILE = "M53.5 71 Q57 74 60.5 71";

/** Blush ellipses — 16% accent-tint, per plan §0 accent budget */
export const BLUSH = [
  { cx: 42, cy: 69, rx: 3.5, ry: 2 },
  { cx: 72, cy: 69, rx: 3.5, ry: 2 },
];

// ── Specks (congratulate / tumble / bounce) ───────────────────────────────────

export const SPECKS = [
  { cx: 46, cy: 32, r: 2 },
  { cx: 62, cy: 26, r: 2.4 },
  { cx: 76, cy: 33, r: 2 },
];
